import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} MM Easy Access. Wszelkie prawa zastrzeżone.
    </footer>
  );
}
